import { render, staticRenderFns } from "./CompanyMonitorPagePreview.vue?vue&type=template&id=53206b3a&scoped=true&"
import script from "./CompanyMonitorPagePreview.vue?vue&type=script&lang=js&"
export * from "./CompanyMonitorPagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53206b3a",
  null
  
)

export default component.exports